<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Usuários</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Usuários"
            api-url="user/list"
            report-title="Usuários"
            :fields="fields"
            :appendParams="filtros"
            :initial-page="pagina"
            :pageCollection="'usuarios'"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-md-2 col-sm-4">
                  <label class="custom-font" for="username_filter"
                    >Usuário</label
                  >
                  <input
                    type="text"
                    v-model="username"
                    class="form-control"
                    name="username_filter"
                  />
                </div>
                <div class="col-md-5 col-sm-8">
                  <label class="custom-font" for="USU_DCEMAIL_filter"
                    >Email</label
                  >
                  <input
                    type="text"
                    v-model="USU_DCEMAIL"
                    class="form-control"
                    name="USU_DCEMAIL_filter"
                  />
                </div>
                <div class="col-md-5 col-sm-12">
                  <label class="custom-font" for="USU_NMUSUARIO_filter"
                    >Nome</label
                  >
                  <input
                    type="text"
                    v-model="USU_NMUSUARIO"
                    class="form-control"
                    name="USU_NMUSUARIO_filter"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'admin_users_save' }"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon> Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import request from '@/request'

export default {
  name: 'users',
  inject: ["showConfirm"],
  data() {
    return {
      fields: [
        {
          name: 'username',
          sortField: 'username',
          title: 'Usuário',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: 'USU_DCEMAIL',
          sortField: 'USU_DCEMAIL',
          title: 'Email',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: 'USU_NMUSUARIO',
          sortField: 'USU_NMUSUARIO',
          title: 'Nome',
          dataClass: 'align-left',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  computed: {
    filtros() {
      const { filtros } = this.$store.state.vuetableState.usuarios
      return { ...filtros }
    },
    pagina: {
      get() {
        const { usuarios } = this.$store.state.vuetableState
        const { pagina } = usuarios
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'usuarios',
          value: value
        })
      }
    },
    username: {
      get() {
        const { usuarios } = this.$store.state.vuetableState
        const { username } = usuarios.filtros
        return username
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'username',
          collection: 'usuarios',
          value: value
        })
      }
    },
    USU_DCEMAIL: {
      get() {
        const { usuarios } = this.$store.state.vuetableState
        const { USU_DCEMAIL } = usuarios.filtros
        return USU_DCEMAIL
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'USU_DCEMAIL',
          collection: 'usuarios',
          value: value
        })
      }
    },
    USU_NMUSUARIO: {
      get() {
        const { usuarios } = this.$store.state.vuetableState
        const { USU_NMUSUARIO } = usuarios.filtros
        return USU_NMUSUARIO
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'USU_NMUSUARIO',
          collection: 'usuarios',
          value: value
        })
      }
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'admin_users_save',
        params: {
          data: data
        }
      })
    },
    excluir(data) {
      var dt = this.$refs.vuetable
      data.type = 'USER'

      var x = data

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.delete(
            x,
            () => {
              dt.refresh()
            },
            () => {
              console.log(
                'houve um error ao tentar excluir este item, por favor tente novamente mais tarde!'
              )
            }
          )
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.username = ''
      this.USU_DCEMAIL = ''
      this.USU_NMUSUARIO = ''
      this.$refs.vuetable.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/index.vue